<template>
  <nav class="mobile-menu-list">
    <ul class="mobile-menu-list__items">
      <li v-for="menu in menus"
          class="mobile-menu-list-item">
        <div class="mobile-menu-list-item-block">
          <is-link
            :href="menu.url"
            :is_link="!menu.active"
            :class="{active: menu.active}"
            :tabindex="menu.active ? -1 : null"
            class="mobile-menu-list-item_link">
            <get-menu-title
              :default_title="menu.title"
              :title_array="menu.titles"/>
          </is-link>
          <span
            v-if="menu.children.length"
            class="ml-5"
            role="button"
            @click.stop.prevent="openChildrenMenu(menu.id)">
             <chevron-down-icon/>
          </span>
        </div>
        <slide-up-down
          v-if="menu.children.length"
          :active="active_dropdown === menu.id">
          <ul class="mobile-menu-list__dropdown-body">
            <li v-for="child_menu in menu.children">
              <is-link
                class="mobile-menu-list-item_link"
                :href="child_menu.url"
                :class="{active: child_menu.active}"
                :tabindex="child_menu.active ? -1 : null"
                :is_link="!child_menu.active">
                <get-menu-title
                  :default_title="child_menu.title"
                  :title_array="child_menu.titles"/>
              </is-link>
            </li>
          </ul>
        </slide-up-down>
      </li>
    </ul>
  </nav>
</template>

<script>
import LogoLink from "./LogoLink.vue";
import BurgerMenu from "./BurgerMenu.vue";
import ChevronDownIcon from "../icons/ChevronDownIcon.vue";
import IsLink from "../slots/IsLink.vue";
import SlideUpDown from "../modules/SlideUpDown.vue";
import GetMenuTitle from "./GetMenuTitle.vue";

export default {
  name: "MobileMenuList",
  components: {
    GetMenuTitle,
    SlideUpDown,
    IsLink,
    ChevronDownIcon,
    BurgerMenu,
    LogoLink
  },
  data() {
    return {
      active_dropdown: 0
    }
  },
  props: {
    menus: {
      type: Array,
      default: () => []
    },
  },
  methods: {
    openChildrenMenu(id) {
      if (this.active_dropdown === id) {
        this.active_dropdown = 0
        return
      }
      this.active_dropdown = id
    }
  }
}
</script>
